<template>
  <div class="xmlMessage">
    <h3>Request FPX AR XML Message</h3>
    <el-row type="flex" class="row-bg" justify="center">
      <el-col :span="12">
        <div class="tobar">
          <el-input @keyup.enter.native="replace" style="margin-bottom:1rem;width:15vw;margin-left:-15px" v-model="url" placeholder="请输入IP"></el-input>
          <el-button class="xml-request-btn" @click="request()" slot="append" icon="el-icon-search">Request</el-button>
          <el-button class="xml-request-btn" @click="replace()" slot="append" icon="el-icon-search">Replace</el-button>
        </div>
      </el-col>
    </el-row>
    <div class="block">
      <el-tree class="filter-tree" :data="treeData" node-key="id" highlight-current check-on-click-node draggable default-expand-all
        :filter-node-method="filterNode" ref="xmlTree" :expand-on-click-node="false">
        <span class="custom-tree-node" slot-scope="{ node, data }">
          <el-input class="xml-title-input__inner" :disabled="data.editDisenabled" v-model="data.key" v-if="data.isTitle"></el-input>
          <el-input v-if="!data.isTitle" v-model="data.key" placeholder="PUT KEY"></el-input>
          <el-input v-if="!data.isTitle" v-model="data.value" placeholder="PUT VALUE"></el-input>
          <span>
            <el-button type="text" size="mini" :disabled="data.appendDisabled" @click="() => append(data)">
              <em class="el-icon-circle-plus"></em>
            </el-button>
            <el-button type="text" size="mini" :disabled="data.removeDisabled" @click="() => remove(node, data)">
              <em class="el-icon-remove"></em>
            </el-button>
            <el-button type="text" size="mini" @click="() => convert(node, data)">
              <em class="el-icon-d-caret"></em>
            </el-button>
          </span>
        </span>
      </el-tree>
    </div>
  </div>
</template>

<script>
  let id = 1000;
  import { AR } from "../../static/xml/XmlTemplate";
  import { htmlEscape, encodeSearchKey } from "../utils/opxpUtil"
  export default {
    name: 'XmlMessage',
    beforeMount() {
    },
    beforeCreate() {
    },
    created() {

    },
    // 监听
    watch: {
      filterText(val) {
        this.$refs.xmlTree.filter(val);
      }
    },
    data() {
      const data = AR
      return {
        url: this.getUrl(),
        // 过滤字符
        filterText: '',
        // 请求方式
        requestOptions: [{ label: 'POST', value: 'POST' }],
        requestMethod: 'POST',
        // 请求地址
        requestUrl: '',
        treeData: JSON.parse(JSON.stringify(data)),
        // 结束标签
        end: [],
        //报文字符串
        xmlString: ''
      }
    },


    methods: {
      getUrl() {
        let first = window.location.href.indexOf(":");
        let url = window.location.href.slice(first + 3);
        let second = url.indexOf(":")
        if (second == -1) {
          second = url.indexOf("/")
        }
        url = url.slice(0, second)
        if (url == "localhost") {
          url = "127.0.0.1";
        }
        return url;
      },

      /*筛选节点*/
      filterNode(value, data) {
        if (!value) return true;
        return data.key.indexOf(value) !== -1;
      },

      /*新增节点*/
      append(data) {
        const newChild = { id: id++, key: '', value: '', children: [] };
        if (!data.children) {
          this.$set(data, 'children', []);
        }
        // 总是增加在第一行
        data.children.splice(0, 0, newChild);
        // data.children.push(newChild);
      },

      /*删除节点*/
      remove(node, data) {
        const parent = node.parent;
        const children = parent.data.children || parent.data;
        const index = children.findIndex(d => d.id === data.id);
        children.splice(index, 1);
      },

      /*转换节点*/
      convert(node, data) {
        this.$set(data, 'isTitle', !data.isTitle);
      },

      /*发送请求*/
      request() {
        this.end = [];
        this.xmlString = '<?xml version=\"1.0\" encoding=\"UTF-8\" ?>';
        this.parseTreeToXml(this.treeData)
        this.xmlString = encodeSearchKey(this.xmlString)
        // this.$router.replace({name:'Login',params:{
        //   data:this.xmlString}
        //   });
        this.$router.replace({ name: 'RequestFromFpx' })
        window.name = this.xmlString
        // this.$http.postXmlMessage(this.requestUrl,this.requestMethod,this.xmlString).then((res)=>{
        //       this.download(this.requestUrl+"[REQUEST]",this.xmlString);
        //       this.download(this.requestUrl+"[RESPONSE]",res.data);
        // }).catch((error) => {
        //   console.log(error)
        //       this.$message('request xml message error!'+'['+error.response.status+']');
        //       throw new Error('request xml message error!')
        // })

      },
      replace() {
        if (this.url == undefined || this.url == null || this.url == '') {
          this.$message.warning('请输入IP');
          return;
        }
        this.end = [];
        this.xmlString = '<?xml version="1.0" encoding="UTF-8" ?>';
        this.parseTreeToXml(this.treeData)
        var value = htmlEscape(this.xmlString)
        var innerHTML = '<input type="hidden" name="mesgToBank" value="' + value + '">'

        var form = document.createElement('form')
        form.style.display = 'none'
        form.action = 'http://' + this.url + '/requestFromFpx'
        form.method = 'post'
        form.name = 'f2'
        form.innerHTML = innerHTML
        document.body.appendChild(form)
        document.getElementsByName(form.name);
        console.log(document)
        form.submit()
      },
      /* 下载 XML 文件 */
      download(name, text) {
        let el = document.createElement('a');
        let dateTime = new Date().getTime();
        el.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text));
        el.setAttribute('download', name + dateTime + ".xml");
        el.style.display = 'none';
        document.body.appendChild(el);
        el.click();
        document.body.removeChild(el)
      },

      /*解析树形结构并转换成xml格式字符串*/
      parseTreeToXml(data) {
        let startNode = '';
        for (let i = 0; i < data.length; i++) {
          // 判断是否存在子节点
          if (data[i].children && data[i].children.length > 0) {
            // 特殊处理了个对象
            if (data[i].key == '' || data[i].key == undefined) {
              // 递归
              this.parseTreeToXml(data[i].children)
            } else {
              startNode = '<' + data[i].key + '>';
              let valueNotNull = data[i].value != undefined && data[i].value != '';
              let startNodeAndValue = valueNotNull ? '<' + data[i].key + '\t' + data[i].value + '>' : startNode;
              // 前缀
              this.xmlString += startNodeAndValue;
              // 后缀
              this.end.push(startNode.replace("<", "</"));
              this.parseTreeToXml(data[i].children)
            }
          } else {
            this.xmlString += '<' + data[i].key + '>' + data[i].value + '</' + data[i].key + '>';
          }
        }
        // 判断足够使用
        if ((this.end.length - 1) > -1) {
          this.xmlString += this.end[this.end.length - 1];
          this.end.splice(this.end.length - 1, 1);
        }
      },
    }
  };
</script>
<style scoped>
  .xml-title-input__inner>>>.el-input__inner {
    background-color: #f15e64;
    width: 100%;
    color: #ffff;
    font-size: 15px;
    border-color: #ffff;
    height: 41px;
    line-height: 41px;
    text-align: center;
  }

  .tobar>>>.el-input-group__prepend {
    background-color: #fff;
    width: 130px;
  }

  .xmlMessage>>>.custom-tree-node {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    padding-right: 8px;
  }

  .xmlMessage>>>.el-tree-node__content {
    height: 41px;
    padding-left: 0px !important;
  }

  .xmlMessage>>>.el-button--text {
    color: #f15e64
  }

  .xmlMessage>>>.xml-title {
    background-color: #f15e64;
    width: 100%;
    color: #ffff;
    height: 40px;
    line-height: 40px
  }

  .xmlMessage>>>.el-input-group__append button.el-button {
    background-color: #f15e64;
    color: #ffff
  }

  .xmlMessage>>>.el-input-group__append button.el-button:hover {
    color: #409EFF;
  }
</style>


// WEBPACK FOOTER //
// src/views/XmlMessage.vue